export default __webpack_public_path__ + "static/media/No.2-3.5ef446ce.jpg";